import React from "react";
import BaseViewController from "./base-view-controller";

class PharmacyListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    const { settings } = this.appData;

    if (name === "selectedData") {
      const {
        pharmacy_nm,
        address: { address_line1, city, state_province, postal },
        work_phone: { phone_number, area_code },
        twenty_four_hour_flg
      } = text;

      this.formState = {
        ...this.formState,
        pharmacy_name: pharmacy_nm,
        pharmacy_details: (
          <>
            {address_line1}
            <br />
            {city},{state_province} {postal}
          </>
        ),
        "phone_faxes.0.phone_number": area_code + phone_number,
        "phone_faxes.1.phone_number": text.work_fax
          ? text.work_fax.area_code + text.work_fax.phone_number
          : null,
        pharmacy_twenty_four_hour: twenty_four_hour_flg ?? "N"
      };
    }
    if (action?.value === "PharmacyAddSearch") {
      this.formState = {
        searchBy: settings.translations.current_location,
        "currentLocation.radius": settings.translations.pharmacy_search_5_miles
      };
    }
    super.handleButtonClick(name, text, action);
  }
}

export default PharmacyListViewController;
